import _ from 'underscore';

// Mixins

// Responsive square images
//	 width can be a string or number. Expected in pixels
var autoSquare = function autoSquare(width) {
	if (!width) {
		console.error("Mixin autoSquare requires parameter 'width'");
	}
	return "\n\t\twidth: " + width + "px;\n\t\tpadding-bottom: " + width + "px;\n\t";
};
// Responsive images - height as a percentage of the width
// Causes fuzzy images with .jpg and .png
//	width must be a number. Expected in pixels
// percent must be a number between 0-1.
var autoHeightPercent = function autoHeightPercent(width, percent) {
	if (!width) {
		console.error("Mixin autoHeightPercent requires parameter 'width'");
		return;
	}
	if (!percent) {
		console.error("Mixin autoHeightPercent requires parameter 'percent'");
		return;
	}
	return "\n\t\twidth: " + width + "px;\n\t\tpadding-bottom: " + width * percent + "px;\n\t";
};

// background image boilerplate
var backgroundImage = function backgroundImage(url) {
	var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "cover";

	return "\n\t\tbackground-image: url( " + url + " );\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-size: " + size + ";\n\t";
};

// Clearfix - forces the parent to clear its children. Use in place of overflow: hidden
//		 uses the :after pseudo element
var clearAfter = function clearAfter() {
	return "\n\t\t&:after {\n\t\t\tcontent: \"\";\n\t\t\tdisplay: table;\n\t\t\tclear: both;\n\t\t}\n\t";
};

// Auto collapsing container
var container = function container() {
	var maxWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "1300px";

	return "\n\t\twidth: 100%;\n\t\tmax-width: " + maxWidth + ";\n\t\tmargin: 0 auto;\n\t";
};

// Placeholder text.
// args: a full css string: `font-size: 14px; ${vars.mainfont} border-radius: 4px;`
// NOTE: vars.mainfont has a ':' at the end
var placeholder = function placeholder(args) {
	return "\n\t\t&::-webkit-input-placeholder {\n\t\t\t" + args + "\n\t\t}\n\t\t&::-moz-placeholder {\n\t\t\t" + args + "\n\t\t}\n\t\t&:-ms-input-placeholder {\n\t\t\t" + args + "\n\t\t}\n\t";
};

// Absolutely positioned ::after box. Must be called on relatively or absolutely
// positioned element.
var shadowbox = function shadowbox() {
	return "\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tz-index: 0;\n\t";
};

// Small caps
// font is a string: "font-family: 'Raleway', Verdana, Geneva, sans-serif; font-weight: 400;"
var smallCaps = function smallCaps(font) {
	return "\n\t\tfont-size: 16px;\n\t\t" + font + ";\n\t\ttext-transform: lowercase;\n\t\tfont-variant: small-caps;\n\t\tletter-spacing: 0.0625em;\n\t";
};

// Standard transitions.
//	argArray: ["arg1", "arg2"]
//	["border-color 350ms ease-out 50ms, visibility 0 linear 400ms"]
var transition = function transition(argArray) {
	return "\n\t\ttransition: " + _.each(argArray, function (arg) {
		return arg;
	}) + "\n\t\t\topacity 350ms ease-out 50ms,\n\t\t\tbackground-color 350ms ease-out 50ms,\n\t\t\tcolor 350ms ease-out 50ms;\n\t";
};

export { autoSquare, autoHeightPercent, backgroundImage, clearAfter, container, placeholder, shadowbox, smallCaps, transition };
//# sourceMappingURL=index.es.js.map
